<template>
    <!-- 添加数据2 -->
    <a-modal title="新增租户" v-model:open="open" @ok="handleOk" class="modals">
        <div class="push-input">
            <a><span class="startColor">*</span>权限名称：</a>
            <a-input v-model:value="pushData.tenantName" maxlength="20" class="push-data" />
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>权限代码：</a>
            <a-input v-model:value="pushData.tenantCode" maxlength="20" class="push-data" />
        </div>
        <template #footer>
            <a-button key="back" @click="toAddCancel">返回</a-button>
            <a-button key="submit" type="primary" :loading="loading" @click="handleOk">提交</a-button>
        </template>
    </a-modal>
</template>
<script>
import { saveTenant } from '@/api/service';
import { message } from 'ant-design-vue';
import { ref } from 'vue';
export default {
    name: 'addComponent',
    setup() {
        const loading = ref(false);//添加提交时的加载
        const pushData = ref({});//提交数据
        const open = ref(false);//是否打开
        //关闭窗口
        const toAddCancel = () => {
            open.value = false;
        }
   
        //提交数据
        const handleOk = async () => {
            console.log(pushData.value);
            const response = await saveTenant(pushData.value);
            if (response.code === 200) {
                message.success('添加成功');
                open.value = false;
            } else {
                message.error('添加失败' + response.msg);
                return false;
            }
        }
        return {
            loading,
            open,
            pushData,
            saveTenant,
            toAddCancel,
            handleOk,
            ref
        };
    }
}
</script>
<style>
.push-input {
    margin-top: 20px;
    display: block;
}

.modals {
    width: 400px;
}

.push-data {
    width: 80%;
}
</style>